// Estatus de Asistencia

const ATTENDANCE_STATUSES = {
  ON_TIME: { value: "ON_TIME", label: "A tiempo", color: "success" },
  LATE: { value: "LATE", label: "Tarde", color: "warning" },
  LEFT_EARLY: { value: "LEFT_EARLY", label: "Salió temprano", color: "warning" },
  NO_SHOW: { value: "NO_SHOW", label: "No asistió", color: "error" },
  ABSENT: { value: "ABSENT", label: "Ausente", color: "error" },
  OVERTIME: { value: "OVERTIME", label: "Horas extra", color: "primary" },
  SCHEDULED: { value: "SCHEDULED", label: "Programado", color: "info" }
};
const DEFAULT_STATUS = ATTENDANCE_STATUSES.SCHEDULED;

export function getAttendanceStatuses() {
  return Object.values(ATTENDANCE_STATUSES);
}

export function getAttendanceStatus(status) {
  return ATTENDANCE_STATUSES[status] || DEFAULT_STATUS;
}

export function getAttendanceStatusLabel(status) {
  return getAttendanceStatus(status).label;
}
